import { BrowserRouter as Router, Route, Routes, useNavigate, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { ChakraProvider, Box, useToast } from '@chakra-ui/react';
import Navbar from './components/Navbar';
import GroupsView from './components/surveyComponents/groups/GroupsView';
import GuestApp from './guestApp';
import MyServices from './components/serviceComponent/MyServices';
import Home from './Home/Home';
import SurveyUpdateComponent from './components/surveyComponents/SurveyUpdateComponent';
//import Footer from './components/Footer';
//import Areatool from './components/AreaTool';
import DatasetView from './components/DatasetView';
import Risultati from './components/Risultati';
import Dashboard from './components/Dashboard';
//import { Box, Grid } from "@chakra-ui/react";
//import Password from './components/cambioPassword';
import DatasetPage from './components/DatasetPage';
import InfoPage from './components/InfoPage';
import './i18n.js'; // Importa la configurazione i18n

import SurveyView from './components/surveyComponents/SurveyView';
import SurveyConsensusView from './components/surveyComponents/SurveyConsensusView.jsx';

import { SessionProvider } from './SessionContext';

import Reindirizzamento from './Reindirizzamento';
import ChartResponseView from './components/surveyComponents/ChartResponseView.jsx';
import DragAndDrop from './components/DragAndDrop';
import DataAnalysis from './components/serviceComponent/DataAnalysis.jsx';
import Safeai from './components/serviceComponent/Safeai.jsx';
import CustomizedOverallRankingEngine from './components/serviceComponent/CustomizedOverallRankingEngine.jsx';

//import Reindirizzamento2 from './Reindirizzamento2';
import JupyterHub from './components/JupyterHub';
import ZeppelinView from './components/Zeppelin';
import SupersetView from './components/Superset';
import StagingAreaView from './components/StagingAreaView';
import ProcessingView from './components/ProcessingView';
//import DashboardView from './components/DashboardView';

import DashboardView from './components/DashboardView';
import SurveyCreator from './components/surveyComponents/SurveyCreator';
import SurveyViewer from './components/surveyComponents/SurveyViewer';
import Services from './components/Catalog/Services';
import IntroServiceView from './components/serviceComponent/IntroServiceView';
import HomeGuest from './components/HomeGuest';
import WelcomePage from './components/WelcomePage';
import ReleasesModal from './components/ReleasesModal';
import UserGuidePage from './components/UserGuidePage';
import CreateGroupComponent from './components/surveyComponents/groups/CreateGroupComponent';
import actionIconsTheme from './themes/actionIconsTheme';
import ExpertView from './components/surveyComponents/experts/ExpertView.jsx';
import StagingAreaViewVAR from './components/StagingAreaView.jsx';
//<Route path="/uploadDataset" element={<DatasetUpload />} />
import MyServicesPlaceHolder from './components/serviceComponent/MyServicesPlaceHolder';
import StatusInformations from './components/StatusInformations.jsx';
import SurveyAnswerView from './components/surveyComponents/SurveyAnswerView.jsx';
import UpdateGroupComponent from './components/surveyComponents/groups/UpdateGroupComponent.jsx';
import { ExchangeDataProvider } from './components/surveyComponents/groups/ExchangeDataProvider.jsx';
import SurveyConsensusCreator from './components/surveyComponents/SurveyConsensusCreator.jsx';
import GroupsConsensusView from './components/surveyComponents/groups/consensus/GroupsConsensusView.jsx';
import SurveyConsensusUpdateComponent from './components/surveyComponents/SurveyConsensusUpdateComponent.jsx';
import SurveyConsensusAnswerView from './components/surveyComponents/SurveyConsensusAnswerView.jsx';
import MyServicesGuest from './components/serviceComponent/MyServicesGuest.jsx';
import FileManagerGrins from './components/surveyComponents/components/fileManager/FileManagerGrins.jsx';
import FileCleaner from './components/surveyComponents/components/file/FileCleaner.jsx';
// import Geoportal from './components/Geoportal.jsx';
// import DigitalAssistant from './components/DigitalAssistant';
import SemanticGraph from './components/SemanticGraph.jsx';
import NovaADP from './components/serviceComponent/SeacomNova/NovaADP.jsx';
import RequestAccessPage from './components/ui/RequestAccessPage.jsx';
import IframeTabsManager from './components/IframeTabsManager.jsx';
// import VideoGuidePage from './components/VideoGuidePage.jsx';
// import { DigitalAssistantProvider } from './context/DigitalAssistantContext.jsx';
// import RoleManagerPage from './components/RoleManagerPage.jsx';
import { getByRole, initMenuStructureHttpService } from './services/http/menuStructureHttpService.js';
import createAxiosInstance from './interceptors/useAxiosInterceptors.js';
import { useTranslation } from 'react-i18next';
import logout from './services/authService.js';
import NavbarDinamic from './components/ui/NavbarDinamic.jsx';
import SpinnerXL from './components/SpinnerXL.jsx';
import UnauthorizedPage from './components/ui/UnauthorizedPage.jsx';
import SessionExpiredPage from './components/ui/SessionExpiredPage.jsx';

// Hook personalizzato per gestire i parametri URL
function useLayoutParams() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  
  // Parametri per controllare header e navbar
  const hideHeader = params.get('hideHeader') === 'true' || params.get('fullscreen') === 'true';
  const hideNavbar = params.get('hideNavbar') === 'true' || params.get('fullscreen') === 'true';
  const fullscreen = params.get('fullscreen') === 'true';
  const embedded = params.get('embedded') === 'true';
  
  return {
    hideHeader,
    hideNavbar,
    fullscreen,
    embedded
  };
}

// Componente wrapper per gestire il layout
function LayoutWrapper({ children }) {
  const { hideHeader, hideNavbar, fullscreen, embedded } = useLayoutParams();
  
  // Se fullscreen o embedded, renderizza solo il contenuto
  if (fullscreen || embedded) {
    return (
      <Box height="100vh" width="100vw" overflow="hidden" bg="#f6f3ec">
        {children}
      </Box>
    );
  }
  
  return (
    <Box
      height="100vh"
      width="100vw"
      display="flex"
      flexDirection="column"
      overflow="hidden"
    >
      {/* Header condizionale */}
      {!hideHeader && (
        <Box width="100%">
          <Header isVisibleMenuLang={true} />
        </Box>
      )}

      <Box
        flex="1"
        display="flex"
        flexDirection="row"
        overflow="auto"
      >
        {/* Navbar condizionale */}
        {!hideNavbar && (
          <Box
            height="100%"
            width="6%"
            bg="rgba(11,78,90,255)"
            paddingTop={5}
            display="flex"
            flexDirection="column"
            boxShadow='inner'
          >
            {/* <Navbar /> */}
            <NavbarDinamic />
          </Box>
        )}

        {/* Area di lavoro con larghezza dinamica */}
        <Box
          width={hideNavbar ? "100%" : "94%"}
          display="flex"
          flexDirection="column"
          overflow="hidden"
          id='workarea'
        >
          {children}
        </Box>
      </Box>

      {/* Footer sempre presente se non fullscreen */}
      <Box width="100%">
        {/* Footer content se necessario */}
      </Box>
    </Box>
  );
}

// funzione per estrarre i path dal menu JSON
function extractAllowedPaths(menu = []) {
  const paths = [];
  function recurse(items) {
    items.forEach(({ path, children = [] }) => {
      if (path && path.trim() !== '') paths.push(path);
      if (children.length) recurse(children);
    });
  }
  recurse(menu);
  return paths;
}


function App() {
  // sessionStorage.setItem("username", "giampieror")
  const [allowedPaths, setAllowedPaths] = useState(null);
  const role = sessionStorage.getItem("role");
  const { t } = useTranslation();
  const toast = useToast();
  const axiosInstance = createAxiosInstance(async (axiosInstance) => {
      logout(t, null, null, toast, axiosInstance)
  });
  const [hasError, setHasError] = useState(null);
  initMenuStructureHttpService(t, toast, axiosInstance);
  
  useEffect(() => {
    getByRole(role)
      .then(res => {
        const menu = res?.data?.menu;
        if (!Array.isArray(menu)) {
          setHasError(true)
          setAllowedPaths(['/']);
          return;
        }
        const extracted = extractAllowedPaths(res.data.menu);

        const dependencies = {
          "/nova": "/my-services",
          "/ceci": "/my-services",
          "/safeai": "/my-services",
          "/file-masking": "/my-services",

          "/semantic-graph": "/dataset",

          "/survey-create": "/surveys",
          "/survey-update/:id": "/surveys",
          "survey-response-chart-view/:id": "/surveys",
          "/experts": "/surveys",
          "/survey-viewer": "/surveys",

          "/group-create": "/surveys",
          "/group-update": "/surveys",
          "/groups-consensus": "/surveys",

          "/survey-consensus-create": "/surveys-consensus",
          "/survey-consensus-update/:id": "/surveys-consensus",
          "/survey-viewer": "/surveys-consensus",
         
        };

        let allowed = [ ...extracted ];
        Object.entries(dependencies).forEach(([path, prereq]) => {
          if (extracted.includes(prereq)) {
            if (!allowed.includes(path)) {
              allowed.push(path);
            }
          } else {
            allowed = allowed.filter(p => p !== path);
          }
        });

        const alwaysAllowed = ['/'];
        const unique = [ ...new Set([ ...allowed, ...alwaysAllowed ]) ];

        setAllowedPaths(unique);
      })
      .catch(() => {
        setHasError(true)
      });
  }, [role]);

  // finché non abbiamo ancora i path consentiti, mostriamo un caricamento
  if (allowedPaths === null) {
    return <SpinnerXL/>;
  }

  return (
    <Router>
      <ExchangeDataProvider>
        <SessionProvider>
          <ChakraProvider theme={actionIconsTheme}>
            {/* <DigitalAssistantProvider> */}
            {!sessionStorage.username ? (
              <Routes>
                {/* Rotte per l'area Guest */}
                <Route path="/*" element={<GuestApp />} />
                <Route path="/survey-answer/:sha_key" element={<SurveyAnswerView />} />
                <Route path="/survey-consensus-answer/:sha_key" element={<SurveyConsensusAnswerView />} />
                <Route path="/request-access" element={ <> <Header isVisibleMenuLang={true} /> <RequestAccessPage /> </>} />
              </Routes>
            ) : (
              sessionStorage.username === "anonymous" ? (
                <Reindirizzamento />
              ) : (
                <LayoutWrapper>
                  <Routes>

                    
                    {/* Tutte le altre routes */}
                    <Route path="/sessionInvalid" element={<SessionExpiredPage />} />
                    <Route path="/unauthorized-page" element={<UnauthorizedPage />} />
                    <Route path="/home" element={allowedPaths.includes('/home') ? <Home /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/" element={<IframeTabsManager />} /> 
                    <Route path="/dataset" element={allowedPaths.includes('/dataset') ? <DatasetPage /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/dashboard" element={allowedPaths.includes('/dashboard') ? <Dashboard /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/risultati" element={allowedPaths.includes('/risultati') ? <Risultati /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/processing" element={allowedPaths.includes('/processing') ? <ProcessingView /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/stagingarea" element={allowedPaths.includes('/stagingarea') ? <StagingAreaView /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/service-intro" element={<IntroServiceView />} />
                    <Route path="/query" element={allowedPaths.includes('/query') ? <DragAndDrop /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/data-analysis" element={allowedPaths.includes('/data-analysis') ? <DataAnalysis /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/safeai" element={allowedPaths.includes('/safeai') ? <Safeai /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/ceci" element={allowedPaths.includes('/ceci') ? <CustomizedOverallRankingEngine /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/survey-create" element={allowedPaths.includes('/survey-create') ? <SurveyCreator /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/survey-consensus-create" element={allowedPaths.includes('/survey-consensus-create') ?<SurveyConsensusCreator /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/survey-update/:id" element={allowedPaths.includes('/survey-update/:id') ?<SurveyUpdateComponent /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/survey-consensus-update/:id" element={allowedPaths.includes('/survey-consensus-update/:id') ?<SurveyConsensusUpdateComponent /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/survey-response-chart-view/:id" element={allowedPaths.includes('/survey-response-chart-view/:id') ?<ChartResponseView /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/lca-catalog" element={allowedPaths.includes('/lca-catalog') ? <FileManagerGrins /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/file-masking"  element={allowedPaths.includes('/file-masking') ? <FileCleaner /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/survey-answer/:sha_key" element={<SurveyAnswerView />} />
                    <Route path="/survey-consensus-answer/:sha_key" element={<SurveyConsensusAnswerView />} />
                    <Route path="/group-update" element={<UpdateGroupComponent />} />
                    <Route path="/groups" element={allowedPaths.includes('/groups') ? <GroupsView /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/groups-consensus" element={<GroupsConsensusView />} />
                    <Route path="/group-create" element={allowedPaths.includes('/group-create') ? <CreateGroupComponent /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/experts"  element={allowedPaths.includes('/experts') ? <ExpertView /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/surveys" element={allowedPaths.includes('/surveys') ? <SurveyView /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/surveys-consensus" element={allowedPaths.includes('/surveys-consensus') ? <SurveyConsensusView /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/survey-viewer" element={allowedPaths.includes('/survey-viewer') ? <SurveyViewer /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/JupyterHub" element={allowedPaths.includes('/JupyterHub') ? <JupyterHub /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/Zeppelin" element={allowedPaths.includes('/Zeppelin') ? <ZeppelinView /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/Superset" element={allowedPaths.includes('/Superset') ? <SupersetView /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/iframe" element={<DashboardView />} />
                    <Route path="/info" element={allowedPaths.includes('/info') ? <InfoPage /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/welcomepage" element={<WelcomePage />} />
                    <Route path="/releases" element={<ReleasesModal />} />
                    <Route path="/userguide" element={<UserGuidePage />} />
                    <Route path="/my-services" element={allowedPaths.includes('/my-services') ?<MyServices /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/my-services-guest" element={<MyServicesGuest />} />
                    <Route path="/status-informations" element={allowedPaths.includes('/status-informations') ? <StatusInformations /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/semantic-graph" element={allowedPaths.includes('/semantic-graph') ? <SemanticGraph /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                    <Route path="/nova" element={allowedPaths.includes('/nova') ? <NovaADP /> : <Navigate to="/unauthorized-page?hideNavbar=true" replace />} />
                  </Routes>
                </LayoutWrapper>
              )
            )}
            {/* </DigitalAssistantProvider> */}
          </ChakraProvider>
        </SessionProvider>
      </ExchangeDataProvider>
    </Router>
  );
}

export default App;

/*
ESEMPI DI UTILIZZO DEI PARAMETRI GET:

1. Nascondere solo l'header:
   http://localhost:3000/home?hideHeader=true

2. Nascondere solo la navbar:
   http://localhost:3000/home?hideNavbar=true

3. Nascondere entrambi:
   http://localhost:3000/home?hideHeader=true&hideNavbar=true

4. Modalità fullscreen (nasconde tutto):
   http://localhost:3000/tabs?fullscreen=true
   http://localhost:3000/query?fullscreen=true

5. Modalità embedded (per iframe):
   http://localhost:3000/dashboard?embedded=true

6. IframeTabsManager sempre fullscreen:
   http://localhost:3000/tabs
   http://localhost:3000/tabs?fullscreen=true

7. Combinazioni personalizzate:
   http://localhost:3000/query?hideNavbar=true
   http://localhost:3000/dashboard?hideHeader=true&hideNavbar=true

NOTA: Il parametro 'fullscreen=true' è equivalente a 'hideHeader=true&hideNavbar=true'
*/